
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Agent } from "@/models/agent";

interface AgentMetadataProps {
  agent: Agent;
}

export const AgentMetadata: React.FC<AgentMetadataProps> = ({ agent }) => {
  return (
    <Card>
      <CardContent className="p-4 text-sm">
        <div className="flex justify-between mb-2">
          <span className="text-muted-foreground">Version</span>
          <span className="font-medium">{agent.version || "1.0.0"}</span>
        </div>
        <div className="flex justify-between mb-2">
          <span className="text-muted-foreground">License</span>
          <span className="font-medium">{agent.license || "MIT"}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-muted-foreground">Updated</span>
          <span className="font-medium">{new Date(agent.updatedAt).toLocaleDateString()}</span>
        </div>
      </CardContent>
    </Card>
  );
};
